import { fuseFilter, nullOrUndefined } from '@/plugins/fuse'
import { SSharedList } from '@/services/shared'
import QUERY from 'lodash'

export default {
  data () {
    return {
      fetching: {
        roles: false
      },
      options: {
        roles: []
      },
      selected: {
        role: ''
      },
      editable: {
        role: ''
      }
    }
  },

  methods: {

    async getRoles (context, search = '') {
      const selectedContext = context?.selected
      const fetchingContext = context?.fetching
      const optionsContext = context?.options

      if (nullOrUndefined(selectedContext) || nullOrUndefined(fetchingContext) || nullOrUndefined(optionsContext)) {
        throw Error('Invalid context object')
      }

      const selected = context.selected?.role
      const fetching = context.fetching?.roles
      const options = context.options?.roles

      if (nullOrUndefined(selected) || nullOrUndefined(fetching) || nullOrUndefined(options)) {
        throw Error('Invalid context object')
      }

      context.fetching.roles = true
      context.selected.role = ''

      const filters = {
        filter_text: search
      }

      return await SSharedList.getRoles(filters).then(
        ({ data }) => {
          context.options.roles = data
        }
      ).catch(() => {
        context.options.roles = []
      }).finally(() => {
        context.fetching.roles = false
      })
    },

    async searchRoles (search, loading) {
      this.searchRolesProvider(this, search, loading)
    },

    searchRolesProvider: QUERY.debounce(
      ({ options }, search, loading) => {
        const filteredOptions = fuseFilter(search, options.roles, {
          keys: ['role_name']
        })

        if (filteredOptions.length < 1) {
          loading(true)

          const filters = {
            filter_text: search
          }

          SSharedList.getRoles(filters).then(
            ({ data }) => {
              options.roles = data
            }
          ).catch(() => {
            options.roles = []
          }).finally(() => {
            loading(false)
          })
        }
      }, 500
    )
  }
}
